export default "__VITE_ASSET__Cq4NFr8D__"